import React from "react";
import { Link, useNavigate } from "react-router-dom";
import MobileStaffLayout from "../../components/mobile-staff/MobileStaffLayout";
import { useAuth } from "../../contexts/AuthContext";
import { LogOut, ShieldCheck, Calculator, Sparkles, Database, BookOpen, ArrowRight } from "lucide-react";

export default function StaffProfil() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const items = [
    { to: "/credit-sim", icon: Calculator, label: "Simulateur de crédit" },
    { to: "/prospects", icon: Sparkles, label: "Prospects" },
    { to: "/securite", icon: ShieldCheck, label: "Sécurité (2FA)" },
    { to: "/documents", icon: BookOpen, label: "Bibliothèque documentaire" },
    { to: "/sauvegardes", icon: Database, label: "Sauvegardes", adminOnly: true },
  ];

  return (
    <MobileStaffLayout title="Mon compte">
      <div className="px-5 pt-5">
        <div className="bg-gradient-to-br from-[#0F1A3D] to-[#1E3A8A] text-white rounded-2xl p-5">
          <div className="w-14 h-14 rounded-full bg-white/15 text-white flex items-center justify-center text-base font-bold mb-3">
            {(user?.name || user?.email || "?").slice(0, 2).toUpperCase()}
          </div>
          <div className="font-display text-lg font-bold leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            {user?.name || user?.email}
          </div>
          <div className="text-xs text-white/70 mt-1 capitalize">{user?.role}</div>
        </div>

        <div className="mt-5 bg-white border border-[#E2E5F1] rounded-2xl divide-y divide-[#F1F3FB]" data-testid="ms-profil-menu">
          {items.filter((it) => !it.adminOnly || user?.role === "admin").map((it) => {
            const Ic = it.icon;
            return (
              <Link key={it.to} to={it.to} className="flex items-center gap-3 px-4 py-3.5 active:bg-[#F8FAFC]">
                <Ic className="w-5 h-5 text-[#1E3A8A]" />
                <div className="flex-1 text-sm font-bold text-[#0F1A3D]">{it.label}</div>
                <ArrowRight className="w-4 h-4 text-[#9CA3B5]" />
              </Link>
            );
          })}
        </div>

        <button
          onClick={() => { logout(); navigate("/login"); }}
          className="w-full mt-5 h-12 rounded-md border-2 border-[#C83B3B] text-[#C83B3B] text-xs font-bold uppercase tracking-wider inline-flex items-center justify-center gap-2 active:bg-[#C83B3B] active:text-white"
          data-testid="ms-logout"
        >
          <LogOut className="w-4 h-4" /> Se déconnecter
        </button>

        <div className="text-center text-[10px] text-[#9CA3B5] mt-4">TPCO Staff — v1.0</div>
      </div>
    </MobileStaffLayout>
  );
}
